import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     id: bfa8a87b-1838-4a22-9838-c908d28f0e0c
//     expiration: '2021-12-31T17:32:28Z'
// };

export default class PublicLinkModel extends BaseModel {
    id = "";
    expiration = "";

    constructor(data) {
        super();
        this.update(data);
    }
}
